import {GraphConfig, graphConfigSchema} from '../types/GraphTypes';

export interface ParseGraphJsonResultSuccess {
  success: true;
  config: GraphConfig;
}

export interface ParseGraphJsonResultError {
  success: false;
  error: string;
}

export type ParseGraphJsonResult = ParseGraphJsonResultSuccess | ParseGraphJsonResultError;

export function parseGraphJsonString(graphJsonString: string | null | undefined): ParseGraphJsonResult {
  if (!graphJsonString || typeof graphJsonString !== 'string') {
    return {success: false, error: 'Graph JSON string is empty or invalid'};
  }

  try {
    const parsed = JSON.parse(graphJsonString);
    const result = graphConfigSchema.safeParse(parsed);

    if (!result.success) {
      const errorMessages = result.error.issues.map((err) => `${err.path.join('.')}: ${err.message}`).join(', ');
      return {
        success: false,
        error: `Validation failed: ${errorMessages}`,
      };
    }

    return {success: true, config: result.data};
  } catch (error) {
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Failed to parse JSON',
    };
  }
}
